export default __webpack_public_path__ + "static/media/button.adda0f21.svg";